import MajorSelect from "./MajorSelect";

export default MajorSelect;
